import {setFilterForCompanies} from "store/filter/filterActions";
import {
	companyAssetIntensitySelector,
	companyBusinessModelSelector,
	companyCommercialMotionSelector,
	companyCompanyStageSelector,
	companyCompetitivePositioningSelector,
	companyCustomerBaseSelector,
	companyDealComplexitySelector,
	companyOperatingRhythmSelector,
	companyOrgComplexitySelector,
	companyOwnershipSelector,
	companyRegulationSelector,
	companySectorTagsSelector,
	companySpecialityTagsSelector,
	companyTechOrientationSelector,
} from "store/filter/filterSelectors";
import {TAppDispatch, TRootState} from "types";

/**
 * Factory that creates a thunk action creator for toggling a string id in/out of a
 * company filter array.  Avoids duplicating the same read-splice-dispatch pattern for
 * every advanced filter type.
 */
const createToggleFilterAction =
	(selector: (state: TRootState) => string[], filterType: string) =>
	({id}: {id: string}) =>
	(dispatch: TAppDispatch, getState: () => TRootState) => {
		const selected = selector(getState());
		const idx = selected.indexOf(id);
		const nextValues =
			idx !== -1
				? [...selected.slice(0, idx), ...selected.slice(idx + 1)]
				: [...selected, id];

		dispatch(setFilterForCompanies({type: filterType, values: nextValues}));
	};

export const setAssetIntensityForCompany = createToggleFilterAction(
	companyAssetIntensitySelector,
	"asset_intensity",
);

export const setBusinessModelForCompany = createToggleFilterAction(
	companyBusinessModelSelector,
	"business_model",
);

export const setCommercialMotionForCompany = createToggleFilterAction(
	companyCommercialMotionSelector,
	"commercial_motion",
);

export const setCompanyStageForCompany = createToggleFilterAction(
	companyCompanyStageSelector,
	"company_stage",
);

export const setCompetitivePositioningForCompany = createToggleFilterAction(
	companyCompetitivePositioningSelector,
	"competitive_positioning",
);

export const setCustomerBaseForCompany = createToggleFilterAction(
	companyCustomerBaseSelector,
	"customer_base",
);

export const setDealComplexityForCompany = createToggleFilterAction(
	companyDealComplexitySelector,
	"deal_complexity",
);

export const setOperatingRhythmForCompany = createToggleFilterAction(
	companyOperatingRhythmSelector,
	"operating_rhythm",
);

export const setOrgComplexityForCompany = createToggleFilterAction(
	companyOrgComplexitySelector,
	"org_complexity",
);

export const setOwnershipForCompany = createToggleFilterAction(
	companyOwnershipSelector,
	"ownership",
);

export const setRegulationForCompany = createToggleFilterAction(
	companyRegulationSelector,
	"regulation",
);

export const setTechOrientationForCompany = createToggleFilterAction(
	companyTechOrientationSelector,
	"tech_orientation",
);

export const setSectorTagsForCompany = createToggleFilterAction(
	companySectorTagsSelector,
	"sector_tags",
);

export const setSpecialityTagsForCompany = createToggleFilterAction(
	companySpecialityTagsSelector,
	"speciality_tags",
);
